import React from 'react';
import { PaymentAddedActivity } from '../../../../../model/activity';
import './ActivityItems.css';
import { KeyValueTable } from '../../../../../components/KeyValueTable/KeyValueTable';
import { t } from '../../../../../locales/translate';
import { formatCurrency } from '../../../../../util/util';

export function PaymentAddedActivity({ activity }: { activity: PaymentAddedActivity }): JSX.Element | null {
  const bankAccount = activity.modifications?.bankAccount;

  return (
    <div className="paymentAdded">
      <KeyValueTable
        items={[
          {
            key: t.model.bank.amount,
            value: formatCurrency(activity.modifications?.amount),
          },
          {
            key: t.model.bank.recipient,
            value: bankAccount?.name,
          },
          {
            key: t.model.bank.bankName,
            value: bankAccount?.bankName,
          },
          {
            key: t.model.bank.iban,
            value: bankAccount?.iban,
          },
          {
            key: t.model.bank.bic,
            value: bankAccount?.bic,
          },
        ]}
      />
    </div>
  );
}
